module.exports = __webpack_public_path__ + "static/media/m.d2e27a94.jpg";